import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../../../components/button';

interface Props {
  content: RiskItem | null;
  isOpen: boolean;
  onClose: () => void;
}

const ValidationDetailBtmSheet = ({content, isOpen, onClose}: Props) => {
  if (!content) return null;

  const details = Array.isArray(content.details)
    ? content.details
    : [content.details];

  return (
    <BottomSheet
      open={isOpen}
      onDismiss={onClose}
      blocking
      className="custom-bottom-sheet"
    >
      <div className="relative flex flex-col w-full gap-3 p-6">
        <i
          className="absolute text-2xl text-gray-500 cursor-pointer icon-nameClose-remove top-6 left-6"
          onClick={onClose}
        />

        <p className="text-lg font-bold text-center text-gray-950">
          {content.title}
        </p>

        <span className="px-3 text-gray-700 text-md">شامل موارد زیر است:</span>

        <ul className="px-3 text-gray-700 list-disc list-inside text-md">
          {details.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>

        <Button onClick={onClose}>بستن</Button>
      </div>
    </BottomSheet>
  );
};

export default ValidationDetailBtmSheet;
